export const FiltersFilledIcon = () => (
  <svg
    width="26"
    height="27"
    viewBox="0 0 26 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 6H2L10 15.46V22L14 24V15.46L22 6Z"
      stroke="#5D6293"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle cx="21" cy="5" r="5" fill="#00B48D" />
  </svg>
);
